import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardComponent } from '../../../../shared/components/card/card.component';
import { IconComponent } from '../../../../shared/icons/icon.component';
import { RuleListItemComponent } from '../../../rules/components/rule-list-item/rule-list-item.component';
import { RuleViewModel } from '../../../rules/models/rule-view-model.interface';

@Component({
  selector: 'app-device-rules-card',
  imports: [TranslatePipe, CardComponent, IconComponent, RuleListItemComponent],
  templateUrl: './device-rules-card.component.html',
  styleUrl: './device-rules-card.component.scss',
})
export class DeviceRulesCardComponent {
  @Input() rules: RuleViewModel[] = [];
  @Input() disabled: boolean = false;
  @Output() createRule = new EventEmitter<void>();
}
